import { useEffect } from "react";

// Persist which booking drawer is open in the URL (?drawer=<lineId>) so a full page reload (Ctrl+R /
// F5) reopens the same booking. Uses history.replaceState — no Inertia visit, no history spam.
const PARAM = "drawer";
// The open payment, so a reload (or a shared URL) lands back on the same payment rather than on the
// booking's charge composer.
const PAY_PARAM = "pay";

export const readPaymentId = () => {
  if (typeof window === "undefined") {
    return null;
  }
  return new URLSearchParams(window.location.search).get(PAY_PARAM) || null;
};

export const readDrawerLineId = () => {
  if (typeof window === "undefined") {
    return null;
  }
  return new URLSearchParams(window.location.search).get(PARAM) || null;
};

export const useDrawerUrlSync = (drawerLineId) => {
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    const url = new URL(window.location.href);
    if (drawerLineId) {
      url.searchParams.set(PARAM, drawerLineId);
    } else {
      url.searchParams.delete(PARAM);
      url.searchParams.delete(PAY_PARAM);
    }
    window.history.replaceState(window.history.state, "", url);
  }, [drawerLineId]);
};

// Same replaceState discipline as the drawer: no Inertia visit, no history spam.
export const usePaymentUrlSync = (paymentId) => {
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    const url = new URL(window.location.href);
    if (paymentId) {
      url.searchParams.set(PAY_PARAM, paymentId);
    } else {
      url.searchParams.delete(PAY_PARAM);
    }
    window.history.replaceState(window.history.state, "", url);
  }, [paymentId]);
};
